import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ProfileGuard } from '@guards/profile/profile.guard';
import {
  LicenseResolver,
  CoursesResolver,
  ClientResolver,
  CourseResolver,
  CountriesResolver,
  LocalesResolver
} from 'core/resolvers';
import { GamesColumnsResolver } from 'core/resolvers/games-columns.resolver';
import { LicenseSessionsResolver } from './resolvers/license-sessions.resolver';
import { LicenseDetailComponent } from './license-detail/license-detail.component';
import { LicenseReportComponent } from './license-report/license-report.component';

const licensesRoutes: Routes = [
  {
    path: 'licenses',
    title: 'parentLicenses',
    resolve: {
      countries: CountriesResolver,
      locales: LocalesResolver,
      courses: CoursesResolver,
      gamesColumns: GamesColumnsResolver
    },
    children: [
      {
        path: ':licenseId',
        title: 'licenseId',
        resolve: {
          license: LicenseResolver,
          reportData: LicenseSessionsResolver
        },
        canActivate: [ProfileGuard],
        data: { action: 'licenses.detail' },
        children: [
          {
            path: '',
            title: 'licenseIdDetail',
            component: LicenseDetailComponent,
            resolve: {
              course: CourseResolver,
              client: ClientResolver
            },
            data: { action: 'licenses.idDetail', preloader: 'secondary' }
          },
          {
            path: 'report',
            title: 'licenseReport',
            resolve: {
              course: CourseResolver
            },
            component: LicenseReportComponent,
            canActivate: [ProfileGuard],
            data: { action: 'licenses.report' }
          }
        ]
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(licensesRoutes)],
  exports: [RouterModule]
})
export class LicensesRoutingModule {}
